export default __webpack_public_path__ + "static/media/koininvoice-syarat-pengajuan.e40e3e8b.png";